import React, {useEffect, useMemo, useRef, useState} from 'react';
import { createPortal } from 'react-dom';
import * as pdfjsLib from 'pdfjs-dist';
import axios from 'axios';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import './calculateOfferModal.scss'
import PlusIconLink from '../../../assets/icons/plus.svg'
import FileIcon from '../../../assets/icons/file-text.svg'
import {FormattedMessage, injectIntl, useIntl} from 'react-intl'
import Product from './Product'
import DiscountedPrice from './DiscountedPrice'
import {withRouter} from 'react-router';
import {RootState} from '../../../reducers';
import {connect} from 'react-redux';
import {Dispatch, bindActionCreators} from 'redux';
import * as actions from '../../../actions/generalActions';
import * as productionActions from '../../../actions/production'
import * as offerActions from '../../../actions/offers';
import {OfferProduct} from '../../../types/offerProduct.type'
import {Button} from '../../../components/Button'
import {PrintedContentV2 as PrintedContent} from './PrintedContentV2';
import ArticleListAndCreateForm from '../../Admin/Article/ArticleListAndCreateForm'
import xSign from '../../../assets/icons/xSign.svg'
import * as Yup from "yup";
import * as validationConfigs from '../../../utils/validationConfigs';
import FormikFormWrapper from '../../../components/FormikFormWrapper/FormikFormWrapper'
import {axiosCaller, apiUrl, getActiveBearerToken} from "../../../utils/apiCaller";
import Spinner from "../../../components/Spinner";
import {toFixedNumber, formatPrice} from '../../../utils/react'
import Tooltip from 'rc-tooltip';
import {ModalContent} from '../../../types/modalContent.type';
import {formatDate} from '../../../utils/variableEvaluation';
import moment from "moment";
import {toast} from "react-toastify";
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {isMobile} from "../../../constants/constants";
import DifferentColoredPlus from "../../../assets/icons/differentColoredPlus.svg";
import HotkeyButton from "../../../components/HotkeyButton/HotkeyButton";
import MikaSelect from "../../../components/BbrosSelect/mikaSelect.component";
import {SelectOption} from "../../../types/selectOption.type";
import {useParams} from "react-router-dom";
import {ParameterTypes} from "../../../types/parameter.type";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// ── Month-browsing calendar header ────────────────────────────────────────────
// Month names come from Intl.DateTimeFormat at render time, using the current
// react-intl locale — so they retranslate when the user switches language.
interface CalendarHeaderProps {
    date: Date; changeYear: (y: number) => void; changeMonth: (m: number) => void;
    decreaseMonth: () => void; increaseMonth: () => void;
    prevMonthButtonDisabled: boolean; nextMonthButtonDisabled: boolean;
}
const CalendarHeader: React.FC<CalendarHeaderProps> = ({
    date, changeYear, changeMonth, decreaseMonth, increaseMonth,
    prevMonthButtonDisabled, nextMonthButtonDisabled
}) => {
    const { locale } = useIntl();
    const [showMonths, setShowMonths] = useState(false);
    const headerRef = useRef<HTMLDivElement>(null);
    const year = date.getFullYear();
    const month = date.getMonth();

    const MONTHS = useMemo(() => {
        const fmt = new Intl.DateTimeFormat(locale, { month: 'long' });
        return Array.from({ length: 12 }, (_, i) =>
            fmt.format(new Date(2000, i, 1)).replace(/^./, c => c.toUpperCase())
        );
    }, [locale]);

    useEffect(() => {
        const cal = headerRef.current?.closest('.react-datepicker') as HTMLElement | null;
        if (!cal) return;
        const container = cal.querySelector('.react-datepicker__month-container') as HTMLElement | null;
        if (showMonths) {
            cal.classList.add('month-picker-active');
        } else {
            cal.classList.remove('month-picker-active');
            if (container) container.style.minHeight = '';
        }
    }, [showMonths]);

    function openMonthPicker() {
        const cal = headerRef.current?.closest('.react-datepicker') as HTMLElement | null;
        const container = cal?.querySelector('.react-datepicker__month-container') as HTMLElement | null;
        if (container) container.style.minHeight = container.offsetHeight + 'px';
        setShowMonths(true);
    }

    if (showMonths) return (
        <div ref={headerRef} className="dp-header dp-header--months">
            <div className="dp-year-nav">
                <button type="button" className="dp-nav-btn" onClick={() => changeYear(year - 1)}>‹</button>
                <span className="dp-year-label">{year}</span>
                <button type="button" className="dp-nav-btn" onClick={() => changeYear(year + 1)}>›</button>
            </div>
            <div className="dp-month-grid">
                {MONTHS.map((m, i) => (
                    <button type="button" key={m}
                        className={`dp-month-btn${month === i ? ' active' : ''}`}
                        onClick={() => { changeMonth(i); setShowMonths(false); }}>
                        {m}
                    </button>
                ))}
            </div>
        </div>
    );
    return (
        <div ref={headerRef} className="dp-header">
            <button type="button" className="dp-nav-btn" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>‹</button>
            <button type="button" className="dp-month-year-btn" onClick={openMonthPicker}>
                {MONTHS[month]} {year} <span className="dp-chevron">▾</span>
            </button>
            <button type="button" className="dp-nav-btn" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>›</button>
        </div>
    );
};

interface Props {
    history: any;
    offers: any;
    offerActions: any;
    client: any;
    actions: any;
    admin: any;
    intl: any;
    location: any;
    closeModalFunction: (boolean) => void
    permissions: any
    pricesIncluded: boolean
    buttonLoader: boolean
    getProductsOfClient: any
    products: any,
    setProducts: any
    productsLoading: any
    setProductsLoading: any
    productionActions: any
    projectDetails: any
    onPdfSaved?: () => void
    allOfferFields?: any[]
    onOfferSaved?: () => void
    companyProfile?: any
}

// ── Modern currency picker ──────────────────────────────────────────
// A native <select> can't style its open option list (the OS draws it), so
// this is a small custom dropdown: a trigger + our own popup, matching the
// rest of the modal. Used for the installation service currency.
// Codes only (EUR / CHF / USD), no symbols — consistent across all three.
const CURRENCY_OPTIONS = ['EUR', 'CHF', 'USD'];

const CurrencyDropdown: React.FC<{ value: string; onChange: (code: string) => void; title?: string }> = ({ value, onChange, title }) => {
    const [open, setOpen] = useState(false);
    const [pos, setPos] = useState<{ top: number; right: number } | null>(null);
    const triggerRef = useRef<HTMLButtonElement>(null);
    const menuRef = useRef<HTMLUListElement>(null);

    // Anchor the menu to the trigger with fixed coords; it's portaled to <body>
    // (see below) so the modal's overflow can't clip it.
    const openMenu = () => {
        if (triggerRef.current) {
            const r = triggerRef.current.getBoundingClientRect();
            setPos({ top: Math.round(r.bottom + 6), right: Math.round(window.innerWidth - r.right) });
        }
        setOpen(true);
    };

    useEffect(() => {
        if (!open) return;
        const onDoc = (e: MouseEvent) => {
            const t = e.target as Node;
            if (triggerRef.current?.contains(t) || menuRef.current?.contains(t)) return;
            setOpen(false);
        };
        const close = () => setOpen(false);
        document.addEventListener('mousedown', onDoc);
        // Fixed coords can't follow the page, so close on scroll/resize.
        window.addEventListener('scroll', close, true);
        window.addEventListener('resize', close);
        return () => {
            document.removeEventListener('mousedown', onDoc);
            window.removeEventListener('scroll', close, true);
            window.removeEventListener('resize', close);
        };
    }, [open]);

    const current = CURRENCY_OPTIONS.includes(value) ? value : 'EUR';

    return (
        <div className={`offer-currency-dd ${open ? 'is-open' : ''}`}>
            <button
                ref={triggerRef}
                type="button"
                className="offer-currency-dd__trigger"
                onClick={() => (open ? setOpen(false) : openMenu())}
                title={title}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <span className="offer-currency-dd__value">{current}</span>
                <svg className="offer-currency-dd__chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
            </button>
            {open && pos && createPortal(
                <ul
                    ref={menuRef}
                    className="offer-currency-dd__menu"
                    role="listbox"
                    style={{ position: 'fixed', top: pos.top, right: pos.right }}
                >
                    {CURRENCY_OPTIONS.map(code => (
                        <li
                            key={code}
                            role="option"
                            aria-selected={code === value}
                            className={`offer-currency-dd__option ${code === value ? 'is-selected' : ''}`}
                            onClick={() => { onChange(code); setOpen(false); }}
                        >
                            {code}
                        </li>
                    ))}
                </ul>,
                document.body
            )}
        </div>
    );
};

const CalculateOfferModal = (props: Props) => {
    const fm = (id: string, defaultMessage: string, values?: Record<string, any>) =>
        props.intl.formatMessage({ id, defaultMessage }, values);

    const [firstAndLastName, setFirstAndLastName] = useState<string>()
    const [date, setDate] = useState(new Date())
    const [fiscalNumber, setFiscalNumber] = useState<number>()
    const [address, setAddress] = useState<string>()
    const [offerId, setOfferId] = useState<string>()
    const [accountNumber, setAccountNumber] = useState<number>()
    // const [productDiscount, setProductDiscount] = useState<number>(null)
    const [comment, setComment] = useState<string>()
    const commentRef = useRef<HTMLTextAreaElement>(null)
    const autoSizeComment = () => {
        const el = commentRef.current
        if (!el) return
        el.style.height = 'auto'
        el.style.height = `${el.scrollHeight}px`
    }
    // keep the note field sized to its content (covers typing + loading an existing note)
    useEffect(() => { autoSizeComment() }, [comment])
    const [total, setTotal] = useState<number>()
    const [discountedTotal, setDiscountedTotal] = useState<number>()
    const [discountType, setDiscountType] = useState<SelectOption>({} as SelectOption)
    const [discountValue, setDiscountValue] = useState<number>()
    const [discountRapport, setDiscountRapport] = useState<any>('')
    const [showKmsh, setShowKmsh] = useState<boolean>(false)
    const [articleCreationModalOpened, setArticleCreationModalOpened] = useState<boolean>(false)
    const [savePdfLoader, setSavePdfLoader] = useState<boolean>(false)
    const [printLoader, setPrintLoader] = useState<boolean>(false)
    const [saveOfferLoading, setSaveOfferLoading] = useState<boolean>(false)
    const [attachments, setAttachments] = useState<any[]>([])
    const [attachLoading, setAttachLoading] = useState<boolean>(false)
    const [attachUploading, setAttachUploading] = useState<boolean>(false)
    const [printAttachments, setPrintAttachments] = useState<any[]>([])
    // Services (transport/installation for export)
    const [offerServices, setOfferServices] = useState<{serviceType: string; enabled: boolean; price: number; text: string; enabledText?: string; disabledText?: string; currency?: string; discountPrice?: number | null}[]>([])
    const [serviceTemplates, setServiceTemplates] = useState<any[]>([])
    const [servicesCollapsed, setServicesCollapsed] = useState(false)
    const [showDiscount, setShowDiscount] = useState<boolean>(() => {
        try { return localStorage.getItem('mika:offerModal:showDiscount') === 'true'; } catch { return false; }
    })
    useEffect(() => {
        try { localStorage.setItem('mika:offerModal:showDiscount', String(showDiscount)); } catch {}
    }, [showDiscount])
    const projectFileInputRef = useRef<HTMLInputElement>(null)
    const similarFileInputRef = useRef<HTMLInputElement>(null)
    const [initialValues] = useState({
        firstAndLastName: '',
        offer: '',
    })
    const [updatedStartDate, setUpdatedStartDate] = useState<any>()
    const [updatedEndDate, setUpdatedEndDate] = useState<any>()
    // Logo comes as base64 data URL directly from the API now

    const [updateDatesPayload, setUpdateDatesPayload] = useState({
        startDate: '',
        endDate: '',
        articleId: '',
        productId: '',
        quantity: ''
    })

    const closeDateModal = () => setUpdateDatesPayload({ startDate: '', endDate: '', articleId: '', productId: '', quantity: '' })

    const discountTypeOptions = useMemo(() => [
        { label: fm('offer.discount.fixed', 'Fixed'), value: 0 },
        { label: fm('offer.discount.percentage', 'Percentage'), value: 1 },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [props.intl]);

    const selectedDiscountType = discountType?.value != null
        ? discountTypeOptions.find(o => o.value === discountType.value) || null
        : null;

    // When the date-update sub-modal is open, intercept ESC in capture phase
    // so it closes only that modal and never the parent offer modal
    useEffect(() => {
        if (!updateDatesPayload?.productId) return
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.stopImmediatePropagation()
                closeDateModal()
            }
        }
        document.addEventListener('keydown', handleEsc, true)
        return () => document.removeEventListener('keydown', handleEsc, true)
    }, [updateDatesPayload?.productId])

    useEffect(() => {
        console.log('CalculateOfferModal: props.products CHANGED:', props.products);
        console.log('CalculateOfferModal: offerId:', offerId);
        console.log('CalculateOfferModal: projectDetails:', props.projectDetails);
    }, [props.products]);

    useEffect(() => {
        props.actions.fetchArticles()
        setFirstAndLastName(`${props.client?.client?.firstnameAndLastname} ${props.client?.client?.lastName}`)
        setFiscalNumber(props.client?.client?.fiscalNumber)
        setAddress(props.client?.client?.address)
        setOfferId(props.offers?.offerClient?.offerId || props.offers?.offerClient?.id)
        setDate(props.offers?.offerClient?.offerDate)
        setAccountNumber(props.client?.client?.bankAccountNumber)
        // setTotal(props.offers?.offerClient?.offerTotalCalculation)
        setComment(props.offers.offerClient.comment ? props.offers.offerClient.comment : '')
        console.log(props.offers.offerClient?.discountValue,'props.offers.offerClient?.discountType')
        if(props.offers.offerClient?.discountType === 0){
            setDiscountType({label: fm('offer.discount.fixed', 'Fixed'), value: 0})
        }
        if(props.offers.offerClient?.discountType === 1){
            setDiscountType({label: fm('offer.discount.percentage', 'Percentage'), value: 1})
        }
        setDiscountValue(props.offers.offerClient?.discountValue)
    }, [props.offers.offerClient])

    useEffect(() => {
        console.log(discountType, props.offers.offerClient?.discountType,'lekaleka')
    }, [discountType]);

    // Load service templates + existing offer services (for export projects)
    useEffect(() => {
        const isExport = props.projectDetails?.shipmentDestinationId === 2;
        const offId = props.offers?.offerClient?.id;
        if (!isExport || !offId) return;

        // Load both templates and current offer details in parallel
        Promise.all([
            axiosCaller('GET', 'admin/offer-service-templates'),
            axiosCaller('GET', `offers/${offId}/complete-details`),
        ]).then(([tplRes, detailRes]) => {
            const templates = tplRes?.data?.data || [];
            setServiceTemplates(templates);

            const existingServices = detailRes?.data?.data?.offer?.services || [];
            if (existingServices.length > 0) {
                setOfferServices(existingServices.map((s: any) => {
                    const tpl = templates.find((t: any) => t.serviceType === s.serviceType);
                    return {
                        serviceType: s.serviceType,
                        enabled: s.enabled,
                        price: Number(s.price) || 0,
                        text: s.text || '',
                        enabledText: s.enabled ? s.text : (tpl?.enabledText || ''),
                        disabledText: !s.enabled ? s.text : (tpl?.disabledText || ''),
                        // Currency is selectable for installation only; transport stays EUR.
                        currency: s.serviceType === 'transport' ? 'EUR' : (s.currency || 'EUR'),
                        discountPrice: s.discountPrice ?? null,
                    };
                }));
            } else {
                const initial = ['transport', 'installation'].map(type => {
                    const tpl = templates.find((t: any) => t.serviceType === type);
                    return {
                        serviceType: type,
                        enabled: false,
                        price: 0,
                        text: tpl?.disabledText || '',
                        enabledText: tpl?.enabledText || '',
                        disabledText: tpl?.disabledText || '',
                        currency: 'EUR',
                    };
                });
                setOfferServices(initial);
            }
        });
    }, [props.projectDetails?.shipmentDestinationId, props.offers?.offerClient?.id]);

    useEffect(()=>{
        if(updateDatesPayload?.startDate && updateDatesPayload?.endDate){
            setUpdatedStartDate(updateDatesPayload?.startDate)
            setUpdatedEndDate(updateDatesPayload?.endDate)
        }
    },[updateDatesPayload])

    useEffect(() => {
        if (props.offers?.offerClient?.id) {
            fetchAttachments(props.offers.offerClient.id)
        }
    }, [props.offers?.offerClient?.id])

    const fetchAttachments = async (offId: number | string) => {
        setAttachLoading(true)
        try {
            const res = await axiosCaller('GET', `offers/${offId}/attachments?t=${Date.now()}`)
            const data = res?.data?.data || []
            setAttachments(data)
            setPrintAttachments(data)
        } catch (e) {
            console.error('fetchAttachments error:', e)
        } finally {
            setAttachLoading(false)
        }
    }

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                const result = reader.result as string
                resolve(result.split(',')[1])
            }
            reader.onerror = reject
            reader.readAsDataURL(file)
        })
    }

    const handleAttachFiles = async (e: React.ChangeEvent<HTMLInputElement>, type: 'project' | 'similar') => {
        const files = Array.from(e.target.files || [])
        if (!files.length) return
        const offId = props.offers?.offerClient?.id
        if (!offId) {
            toast.error(fm('offer.modal.toast.offerNotLoadedYet', 'The offer is not loaded yet. Please try again.'))
            return
        }
        setAttachUploading(true)
        try {
            for (const file of files) {
                const data = await fileToBase64(file)
                await axiosCaller('POST', `offers/${offId}/attachments`, {
                    data,
                    mimeType: file.type,
                    name: file.name,
                    type,
                })
            }
            toast.success(fm('offer.modal.toast.filesUploadedSuccess', 'Files uploaded successfully!'))
        } catch (e) {
            toast.error(fm('offer.modal.toast.uploadFailed', 'Upload failed!'))
        } finally {
            await fetchAttachments(offId)
            setAttachUploading(false)
            e.target.value = ''
        }
    }

    const handleDeleteAttachment = async (id: number) => {
        try {
            await axiosCaller('DELETE', `offers/attachments/${id}`)
            setAttachments(prev => prev.filter((a: any) => a.id !== id))
            setPrintAttachments(prev => prev.filter((a: any) => a.id !== id))
            toast.success(fm('offer.modal.toast.fileDeletedSuccess', 'File deleted!'))
        } catch (e) {
            toast.error(fm('offer.modal.toast.deleteFailed', 'Delete failed!'))
        }
    }

    const appendAttachmentSection = async (pdf: jsPDF, atts: any[], title: string, subtitle: string): Promise<void> => {
        if (!atts.length) return
        const pageW = pdf.internal.pageSize.getWidth()
        const pageH = pdf.internal.pageSize.getHeight()
        const headerH = 28
        const margin = 10
        let headerDrawn = false

        const drawHeader = () => {
            pdf.setFillColor(26, 26, 26)
            pdf.rect(0, 0, pageW, headerH, 'F')
            pdf.setTextColor(255, 255, 255)
            pdf.setFontSize(14)
            pdf.setFont('helvetica', 'bold')
            pdf.text(title.toUpperCase(), pageW / 2, 11, { align: 'center' })
            pdf.setTextColor(200, 200, 200)
            pdf.setFontSize(9)
            pdf.setFont('helvetica', 'normal')
            pdf.text(subtitle, pageW / 2, 21, { align: 'center' })
        }

        for (const att of atts) {
            if (!att.data) continue
            try {
                if (att.mimeType === 'application/pdf') {
                    const binary = atob(att.data)
                    const pdfData = new Uint8Array(binary.length)
                    for (let i = 0; i < binary.length; i++) pdfData[i] = binary.charCodeAt(i)
                    const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise
                    for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
                        const page = await pdfDoc.getPage(pageNum)
                        const viewport = page.getViewport({ scale: 2 })
                        const canvas = document.createElement('canvas')
                        canvas.width  = viewport.width
                        canvas.height = viewport.height
                        await page.render({ canvasContext: canvas.getContext('2d')!, viewport }).promise
                        pdf.addPage()
                        let startY = 0
                        if (!headerDrawn && pageNum === 1) {
                            drawHeader()
                            headerDrawn = true
                            startY = headerH
                        }
                        const availH = pageH - startY
                        const imgAspect = canvas.width / canvas.height
                        const availAspect = pageW / availH
                        let imgW: number, imgH: number, imgX: number, imgY: number
                        if (imgAspect > availAspect) {
                            imgW = pageW; imgH = pageW / imgAspect
                            imgX = 0;    imgY = startY + (availH - imgH) / 2
                        } else {
                            imgH = availH; imgW = availH * imgAspect
                            imgX = (pageW - imgW) / 2; imgY = startY
                        }
                        pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', imgX, imgY, imgW, imgH)
                    }
                } else {
                    const dataUrl = `data:${att.mimeType};base64,${att.data}`
                    const img = new Image()
                    await new Promise<void>((resolve) => {
                        img.onload = () => resolve()
                        img.onerror = () => resolve()
                        img.src = dataUrl
                    })
                    if (!img.naturalWidth || !img.naturalHeight) continue
                    pdf.addPage()
                    let startY = 0
                    if (!headerDrawn) {
                        drawHeader()
                        headerDrawn = true
                        startY = headerH
                    }
                    const maxW = pageW - margin * 2
                    const maxH = pageH - startY - margin
                    const imgAspect = img.naturalWidth / img.naturalHeight
                    const maxAspect = maxW / maxH
                    let imgW: number, imgH: number
                    if (imgAspect > maxAspect) {
                        imgW = maxW; imgH = maxW / imgAspect
                    } else {
                        imgH = maxH; imgW = maxH * imgAspect
                    }
                    const imgX = (pageW - imgW) / 2
                    const imgY = startY + (pageH - startY - imgH) / 2
                    const format = att.mimeType === 'image/png' ? 'PNG' : 'JPEG'
                    pdf.addImage(dataUrl, format, imgX, imgY, imgW, imgH)
                }
            } catch (e) {
                console.error(`Failed to append attachment ${att.originalName}:`, e)
            }
        }
    }

    const appendPdfAttachments = async (pdf: jsPDF, pdfAtts: any[]): Promise<void> => {
        const pageWidthMm  = pdf.internal.pageSize.getWidth()
        const pageHeightMm = pdf.internal.pageSize.getHeight()
        for (const att of pdfAtts) {
            if (!att.data) continue
            try {
                const binary = atob(att.data)
                const pdfData = new Uint8Array(binary.length)
                for (let i = 0; i < binary.length; i++) pdfData[i] = binary.charCodeAt(i)
                const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise
                for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
                    const page = await pdfDoc.getPage(pageNum)
                    const viewport = page.getViewport({ scale: 2 })
                    const canvas = document.createElement('canvas')
                    canvas.width  = viewport.width
                    canvas.height = viewport.height
                    await page.render({ canvasContext: canvas.getContext('2d')!, viewport }).promise
                    const imgAspect  = canvas.width / canvas.height
                    const pageAspect = pageWidthMm / pageHeightMm
                    let imgW: number, imgH: number, imgX: number, imgY: number
                    if (imgAspect > pageAspect) {
                        imgW = pageWidthMm
                        imgH = pageWidthMm / imgAspect
                        imgX = 0
                        imgY = (pageHeightMm - imgH) / 2
                    } else {
                        imgH = pageHeightMm
                        imgW = pageHeightMm * imgAspect
                        imgX = (pageWidthMm - imgW) / 2
                        imgY = 0
                    }
                    pdf.addPage()
                    pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', imgX, imgY, imgW, imgH)
                }
            } catch (e) {
                console.error(`Failed to append PDF ${att.originalName}:`, e)
            }
        }
    }

    const appendImageAttachments = async (pdf: jsPDF, imgAtts: any[]): Promise<void> => {
        const pageWidthMm  = pdf.internal.pageSize.getWidth()
        const pageHeightMm = pdf.internal.pageSize.getHeight()
        const margin = 10
        const maxW = pageWidthMm - margin * 2
        const maxH = pageHeightMm - margin * 2
        for (const att of imgAtts) {
            if (!att.data) continue
            try {
                const dataUrl = `data:${att.mimeType};base64,${att.data}`
                const img = new Image()
                await new Promise<void>((resolve) => {
                    img.onload = () => resolve()
                    img.onerror = () => resolve()
                    img.src = dataUrl
                })
                if (!img.naturalWidth || !img.naturalHeight) continue
                const imgAspect = img.naturalWidth / img.naturalHeight
                const maxAspect = maxW / maxH
                let imgW: number, imgH: number
                if (imgAspect > maxAspect) {
                    imgW = maxW
                    imgH = maxW / imgAspect
                } else {
                    imgH = maxH
                    imgW = maxH * imgAspect
                }
                const imgX = (pageWidthMm - imgW) / 2
                const imgY = (pageHeightMm - imgH) / 2
                const format = att.mimeType === 'image/png' ? 'PNG' : 'JPEG'
                pdf.addPage()
                pdf.addImage(dataUrl, format, imgX, imgY, imgW, imgH)
            } catch (e) {
                console.error(`Failed to append image ${att.originalName}:`, e)
            }
        }
    }

    const hydrateArticleImages = async (element: HTMLElement): Promise<() => void> => {
        const imgEls = Array.from(element.querySelectorAll<HTMLImageElement>('.article-image-wrapper img'))
        const origSrcs: Array<[HTMLImageElement, string]> = []
        await Promise.all(imgEls.map(async (imgEl) => {
            const src = imgEl.getAttribute('src')
            if (!src || src.startsWith('data:')) return
            const storageIdx = src.indexOf('/storage/')
            if (storageIdx === -1) return
            const storagePath = src.substring(storageIdx + '/storage/'.length)
            try {
                const res = await axiosCaller('GET', `image-proxy?path=${encodeURIComponent(storagePath)}`)
                if (res?.data?.data && res?.data?.mimeType) {
                    origSrcs.push([imgEl, src])
                    imgEl.src = `data:${res.data.mimeType};base64,${res.data.data}`
                }
            } catch (e) {
                console.warn('Could not hydrate article image:', src, e)
            }
        }))
        return () => { origSrcs.forEach(([imgEl, src]) => { imgEl.src = src }) }
    }

    const waitForRender = () => new Promise<void>(resolve =>
        requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
    )

    const waitForImages = (element: HTMLElement): Promise<void> => {
        const imgs = Array.from(element.querySelectorAll<HTMLImageElement>('.print-attachment-image'))
        return Promise.all(
            imgs.map(img => {
                if (img.complete && img.naturalHeight !== 0) return Promise.resolve()
                return new Promise<void>(resolve => {
                    const timeout = setTimeout(() => resolve(), 8000)
                    img.addEventListener('load',  () => { clearTimeout(timeout); resolve() }, { once: true })
                    img.addEventListener('error', () => { clearTimeout(timeout); resolve() }, { once: true })
                })
            })
        ).then(() => {})
    }

    const clientOffer: ModalContent = {
        firstAndLastName,
        date,
        fiscalNumber,
        address,
        invoiceNumber: offerId,
        accountNumber,
        products: props?.products,
        comment,
        offerTotalCalculation: total,
        discountType: discountType?.value ?? null,
        discountValue: discountValue ?? null,
        discountedTotal: discountedTotal ?? null,
        phoneNumber: props.client?.client?.phoneNumber ?? null,
        city: props.client?.client?.city ?? null,
        country: props.client?.client?.country ?? null,
        project: props.projectDetails?.projectName ?? null,
        services: offerServices,
    }



    const saveOffer = async () => {
        let typesArray = []
        let taxArray = []
        let taxPriceArray = []
        let priceArray = []
        let productUnitArray = []
        let discountArray = []
        let designationArray = []
        let startArray = []

        let isNotValid = false
        if(props?.products?.length !== 0){
            props?.products.forEach((product)=>{
                if(!product?.id){
                    isNotValid = true
                }
            })
        }
        if(isNotValid){
            toast?.info(fm('offer.modal.toast.saveProductsBeforeOffer', 'Save the products before saving the offer!'))
            return
        }
        props?.products.forEach((product) => {
            typesArray.push(product.type)
            taxArray.push(product.tax)
            taxPriceArray.push(product.taxPrice)
            priceArray.push(product.price)
            productUnitArray.push(product.unit)
            discountArray.push(product.discount)
            designationArray.push(product.designation)
            startArray.push(product.start)
        })

        props.offerActions.setNameSurnameOffer(firstAndLastName)
        props.offerActions.setDateOffer(formatDate(date))
        props.offerActions.setFiscalNumberOffer(fiscalNumber)
        props.offerActions.setAddress(address)
        props.offerActions.setOfferId(offerId)
        props.offerActions.setAccountNumber(accountNumber)
        props.offerActions.setDiscountValue (discountValue)
        props.offerActions.setDiscountType(discountType)
        props.offerActions.setTypes(typesArray)
        props.offerActions.setTax(taxArray)
        props.offerActions.setTaxPrice(taxPriceArray)
        props.offerActions.setDesignation(designationArray)
        props.offerActions.setDiscount(discountArray)
        props.offerActions.setProductUnit(productUnitArray)
        props.offerActions.setStartDate(startArray)
        props.offerActions.setPrice(priceArray)
        props.offerActions.setProducts(props?.products)
        props.offerActions.setComment(comment)
        props.offerActions.setDiscountTotal(discountedTotal)

        const offId = props.offers.offerClient?.id
        if (!offId) {
            // New offer not yet persisted — just close, general view handles the create
            props.closeModalFunction(false)
            return
        }

        setSaveOfferLoading(true)
        try {
            const offerClient = props.offers.offerClient
            const payload = new FormData()

            payload.append('id', offId)
            if (props.client?.client?.id) payload.append('clientId', `${props.client.client.id}`)
            if (props.client?.client?.address) payload.append('address', props.client.client.address)
            if (offerId) payload.append('offerId', `${offerId}`)
            if (comment) payload.append('comment', comment)

            // Discount — only append if type and value are both present (mirrors CreateOfferForm logic)
            if ((discountType?.value === 0 || discountType?.value === 1) && discountValue) {
                payload.append('discountType', `${discountType.value}`)
                if (discountedTotal) payload.append('discountTotal', `${discountedTotal}`)
                payload.append('discountValue', `${discountValue}`)
            }

            // Passthrough: fields this modal doesn't edit — preserve existing values
            if (offerClient?.offerStatus?.value != null) payload.append('offerStatusId', `${offerClient.offerStatus.value}`)
            if (offerClient?.addition) payload.append('addition', offerClient.addition)
            if (offerClient?.pointOfContact?.value) payload.append('pointOfContactUserId', `${offerClient.pointOfContact.value}`)
            if (offerClient?.installationDate) payload.append('installationDate', offerClient.installationDate)
            // Only pass through dynamic fields that still exist in the current definitions
            if (offerClient?.dynamicFields?.length && props.allOfferFields?.length) {
                offerClient.dynamicFields.forEach((field: any) => {
                    // Only include if the field definition still exists
                    const definitionExists = props.allOfferFields.some((def: any) => def.id === field.id)
                    if (definitionExists) {
                        payload.append('dynamicFieldIds[]', `${field?.id ?? ''}`)
                        payload.append('dynamicFieldValues[]', field?.value ?? '')
                    }
                })
            }

            await axiosCaller('POST', 'offers', payload)
            toast.success(fm('offer.modal.toast.offerSavedSuccess', 'Offer saved successfully!'))

            // Re-fetch offer data so the parent page updates
            if (props.onOfferSaved) {
                props.onOfferSaved()
            }

            props.closeModalFunction(false)
        } catch (e) {
            toast.error(fm('offer.modal.toast.saveFailed', 'Save failed!'))
        } finally {
            setSaveOfferLoading(false)
        }
    }

    const addEmptyOfferProduct = () => {
        let temporaryProductsCopy = [...props?.products]

        temporaryProductsCopy.push({
            designation: {
                label: '',
                value: 0
            },
            discount: 0,
            price: 0,
            tax: 0,
            taxPrice: 0,
            type: '',
            unit: 0,
            value: 0
        })
        props?.setProducts(temporaryProductsCopy)
        props.offerActions.setProducts(props?.products)
    }

    useEffect(() => {
        let allProductTotalPrice = 0
        if (props?.products) {
            props?.products.forEach((product) => {
                if (product.totalPrice && product?.canceled === 0) {
                    allProductTotalPrice += Number(product.totalPrice)
                    // Include sub-products in offer total
                    if (product.subProducts?.length) {
                        product.subProducts.forEach((sp) => {
                            allProductTotalPrice += Number(sp.totalPrice || 0)
                        })
                    }
                }
            })
        }
        // Service prices always count toward the total — the currency is just a
        // display label on the line (this is an offer, not a strict invoice).
        offerServices.forEach(svc => {
            if (svc.enabled) allProductTotalPrice += Number(svc.price || 0);
        });
        setTotal(allProductTotalPrice)
    }, [props?.products, offerServices])

    function validationScheme() {
        return Yup.object().shape({
            firstAndLastName: validationConfigs.NAME_SURNAME_VALIDATION,
            offer: validationConfigs.PRODUCTS_VALIDATION,
        });
    }

    function saveStartAndEndDate() {
        if(moment(updatedStartDate) < moment()){
            toast.error(fm('offer.modal.toast.startDateCannotBeInPast', 'The start date cannot be in the past!'))
            return;
        }

        if(moment(updatedEndDate) < moment(updatedStartDate)){
            toast.error(fm('offer.modal.toast.endDateCannotBeBeforeStart', 'The end date cannot be before the start date!'))
            return;
        }

        if (!updatedStartDate) {
            toast.error(fm('offer.modal.toast.pleaseFillStartDate', 'Please fill in the start date'))
            return
        }

        let payload = {
            productId: Number(updateDatesPayload?.productId),
            start: updatedStartDate ? moment(updatedStartDate).format('YYYY-MM-DD') : '',
            end: updatedEndDate ? moment(updatedEndDate).format('YYYY-MM-DD') : ''
        }

        props.productionActions.updateProductDates(payload).then((res)=>{
            if (res.data) {
                toast.success(fm('offer.modal.toast.datesChangedSuccess', 'Dates changed successfully!'))
                closeDateModal()
                props?.getProductsOfClient()
            } else {
                toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'))
            }
        })
    }

    useEffect(()=>{
        if(discountValue && +discountValue > 0){
            let tempPercentageDiscount = total/100 * discountValue
            if(discountType?.value === 0){
                let tempTotal = total - discountValue
                setDiscountedTotal(tempTotal)
                let temp = (discountValue * 100)/total
                setDiscountRapport(`- ${formatPrice(temp)} %`)
            }
            if(discountType?.value === 1){
                setDiscountedTotal(total - tempPercentageDiscount)
                setDiscountRapport(`- ${formatPrice(tempPercentageDiscount)} €`)
            }
        } else {
            // discount cleared or zeroed — reset everything
            setDiscountedTotal(undefined)
            setDiscountRapport('')
        }
    },[discountValue, discountType, total])

    function handleDiscountTypeChange(newType: SelectOption) {
        // when type changes, the old value is meaningless in the new context — reset it
        if(newType?.value !== discountType?.value) {
            setDiscountValue(undefined)
            setDiscountedTotal(undefined)
            setDiscountRapport('')
        }
        setDiscountType(newType)
    }


    const savePdfToServer = async () => {
        const offerId = props.offers?.offerClient?.id;
        if (!offerId) {
            toast.error(fm('offer.modal.toast.cannotGeneratePdf', 'Could not generate PDF!'));
            return;
        }
        setSavePdfLoader(true);
        try {
            await axiosCaller('POST', `offers/${offerId}/generate-pdf`);
            toast.success(fm('offer.modal.toast.pdfSavedSuccess', 'Offer saved as PDF successfully!'));
            if (props.onPdfSaved) props.onPdfSaved();
        } catch (err) {
            console.error('PDF save error:', err);
            toast.error(fm('offer.modal.toast.pdfSaveFailed', 'Something went wrong while saving the PDF!'));
        } finally {
            setSavePdfLoader(false);
        }
    };

    const printDocument = async () => {
        // Open the new tab synchronously, BEFORE the await — popup blockers reject
        // window.open() that fires from an async callback after a network round-trip.
        // We'll set the tab's URL to the blob URL once the response arrives.
        const previewWindow = window.open('', '_blank');

        setPrintLoader(true);
        try {
            // Resolve which conditions text to send (mirrors the existing PrintedContent prop logic).
            const isExport = props.projectDetails?.shipmentDestinationId === 2;
            const conditionsText = (isExport
                ? props.admin?.offerConditions?.conditionsExport
                : props.admin?.offerConditions?.conditions) || props.offers?.offerMessage || '';

            // Snapshot the live modal state into the payload shape the backend expects.
            // Includes unsaved edits — the whole point of preview.
            const payload = {
                offerId: offerId ?? null,
                offerDate: date ? formatDate(date) : null,
                address: address ?? null,
                fiscalNumber: fiscalNumber ?? null,
                comment: comment ?? null,
                conditionsText,

                discountType: discountType?.value ?? null,
                discountValue: discountValue ?? null,
                discountedTotal: discountedTotal ?? null,

                firstAndLastName: firstAndLastName ?? null,
                client: {
                    phoneNumber: props.client?.client?.phoneNumber ?? null,
                    city: props.client?.client?.city ?? null,
                    country: props.client?.client?.country ?? null,
                },
                project: {
                    name: props.projectDetails?.projectName ?? null,
                    shipmentDestinationId: props.projectDetails?.shipmentDestinationId ?? null,
                },

                products: (props?.products || []).map((p: any) => ({
                    type: p?.type ?? null,
                    unit: p?.unit ?? null,
                    unitName: p?.unitName ?? null,
                    price: p?.price ?? 0,
                    totalPrice: p?.totalPrice ?? 0,
                    canceled: p?.canceled ?? 0,
                    note: p?.note ?? null,
                    designation: p?.designation ? { label: p.designation.label } : null,
                    articleDescription: p?.articleDescription ?? null,
                    articleImage: p?.articleImage ?? null,
                    subProducts: (p?.subProducts || []).map((sp: any) => ({
                        name: sp?.name ?? null,
                        description: sp?.description ?? null,
                        unitName: sp?.unitName ?? null,
                        quantity: sp?.quantity ?? null,
                        effectivePrice: sp?.effectivePrice ?? 0,
                        coefficient: sp?.coefficient ?? 1,
                        totalPrice: sp?.totalPrice ?? 0,
                        sortOrder: sp?.sortOrder ?? 0,
                    })),
                })),

                offerServices: (offerServices || []).map(svc => ({
                    serviceType: svc.serviceType,
                    enabled: !!svc.enabled,
                    price: svc.price ?? 0,
                    text: svc.text ?? '',
                    currency: svc.currency || 'EUR',
                })),

                // When the offer is already saved in the DB, send its ID so the backend
                // can append previously-uploaded attachments. Drafts have no attachments.
                dbOfferId: props.offers?.offerClient?.id ?? null,
            };

            const token = getActiveBearerToken();
            const response = await axios.post(`${apiUrl}offers/preview-pdf`, payload, {
                headers: {
                    'Accept': 'application/pdf',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                responseType: 'blob',
            });

            const blobUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            if (previewWindow) {
                previewWindow.location.href = blobUrl;
            } else {
                // Popup was blocked — fall back to downloading.
                window.open(blobUrl, '_blank');
            }
        } catch (err) {
            console.error('PDF preview error:', err);
            if (previewWindow) previewWindow.close();
            toast.error(fm('offer.modal.toast.printFailed', 'Something went wrong while printing!'));
        } finally {
            setPrintLoader(false);
        }
    };

    return (
        <div className="calculate-offer-modal-background">
            <div className="offer-modal-card position-relative">

                {/* ── Header ── */}
                <div className="offer-modal-header">
                    <div className="d-flex align-items-center print-container">
                        <button
                            disabled={printLoader}
                            className="printButton d-flex align-items-center"
                            onClick={printDocument}>
                            <span className="printButton-icon mx-2">
                                {printLoader ? <Spinner /> : <img src={FileIcon} alt=""/>}
                            </span>
                            <p className="m-0">
                                <FormattedMessage id="offer.modal.printDocument" defaultMessage="Print document"/>
                            </p>
                        </button>
                        <PrintedContent
                            offer={clientOffer}
                            message={(() => {
                                const isExport = props.projectDetails?.shipmentDestinationId === 2;
                                const conditions = isExport
                                    ? props.admin?.offerConditions?.conditionsExport
                                    : props.admin?.offerConditions?.conditions;
                                return conditions || props.offers.offerMessage;
                            })()}
                            attachments={printAttachments}
                            companyProfile={props.companyProfile}
                            logoBase64={props.companyProfile?.logo}
                        />
                    </div>
                    <HotkeyButton
                        keyCode="Escape"
                        modifiers={[]}
                        isActive={false}
                        onStateChange={(state) => {
                            if (state) props.closeModalFunction(false)
                        }}
                    >
                        <div className="offer-modal-close-btn" onClick={() => props.closeModalFunction(false)}>
                            <img src={DifferentColoredPlus} alt={fm('offer.modal.close', 'Close')}/>
                        </div>
                    </HotkeyButton>
                </div>

                <FormikFormWrapper initialValues={initialValues} validationScheme={validationScheme()} onSubmit={saveOffer}>
                    <div className="offer-modal-body">

                        {/* ══════════════ LEFT PANEL ══════════════ */}
                        <div className="offer-modal-left">

                            {/* Consumer info strip — Nr. Ofertes included as editable item */}
                            <div className="consumer-info-strip">
                                <div className="consumer-info-item">
                                    <span className="consumer-info-label"><FormattedMessage id="offer.modal.consumerName" defaultMessage="Name and surname" /></span>
                                    <span className="consumer-info-value">{firstAndLastName || '—'}</span>
                                </div>
                                {props.projectDetails?.projectName && (
                                    <div className="consumer-info-item">
                                        <span className="consumer-info-label"><FormattedMessage id="offer.list.column.project" defaultMessage="Project" /></span>
                                        <span className="consumer-info-value">{props.projectDetails.projectName}</span>
                                    </div>
                                )}
                                <div className="consumer-info-item">
                                    <span className="consumer-info-label"><FormattedMessage id="offer.modal.offerDate" defaultMessage="Offer date" /></span>
                                    <span className="consumer-info-value">{date ? formatDate(date) : '—'}</span>
                                </div>
                                <div className="consumer-info-item">
                                    <span className="consumer-info-label"><FormattedMessage id="offer.modal.address" defaultMessage="Address" /></span>
                                    <span className="consumer-info-value">{address || '—'}</span>
                                </div>
                                <div className="consumer-info-item">
                                    <span className="consumer-info-label"><FormattedMessage id="offer.modal.offerId" defaultMessage="Offer ID" /></span>
                                    <span className="consumer-info-value">{offerId || '—'}</span>
                                </div>
                            </div>
                            {articleCreationModalOpened && (
                                <div className="card create-article-modal">
                                    <div className="cursor-pointer" onClick={() => setArticleCreationModalOpened(false)}>
                                        <img src={xSign} alt=""/>
                                    </div>
                                    <ArticleListAndCreateForm/>
                                </div>
                            )}

                            {/* Product list */}
                            {props?.productsLoading ? <Spinner/> : (
                                <div>
                                    {props?.products && props?.products?.map((product, index) => (
                                        <Product
                                            data={product}
                                            offerId={offerId}
                                            getProductsOfClient={props?.getProductsOfClient}
                                            setUpdateDatesPayload={setUpdateDatesPayload}
                                            products={props?.products}
                                            setProducts={props?.setProducts}
                                            indexWhereThisProductIsPlacedInTheArray={index}
                                            key={index}
                                            discount={product?.discountPrice}
                                            projectDetails={props?.projectDetails}
                                        />
                                    ))}
                                </div>
                            )}

                            {/* Add product + Add article — bottom of product list */}
                            <div className="offer-add-actions">
                                <div className="offer-add-btn" onClick={addEmptyOfferProduct}>
                                    <img src={PlusIconLink} alt="plus" className="offer-add-icon"/>
                                    <span><FormattedMessage id="offer.modal.addProduct" defaultMessage="ADD PRODUCT"/></span>
                                </div>
                                {props.permissions.fullPrivileges && (
                                    <div className="offer-add-btn offer-add-btn--secondary" onClick={() => setArticleCreationModalOpened(true)}>
                                        <img src={PlusIconLink} alt="plus" className="offer-add-icon"/>
                                        <span><FormattedMessage id="offer.modal.addArticle" defaultMessage="ADD ARTICLE"/></span>
                                    </div>
                                )}
                            </div>

                            {/* Services section (export only) */}
                            {props.projectDetails?.shipmentDestinationId === 2 && offerServices.length > 0 && (
                                <div className="offer-services-section">
                                    <div className="offer-services-header">
                                        <span className="offer-services-title" onClick={() => setServicesCollapsed(c => !c)}>
                                            <FontAwesome name="chevron-down" className={`offer-services-chevron ${servicesCollapsed ? 'is-collapsed' : ''}`}/>
                                            <FormattedMessage id="offer.modal.services.title" defaultMessage="Services" />
                                        </span>
                                        <button
                                            type="button"
                                            className="offer-services-save-btn"
                                            onClick={async () => {
                                                const offId = props.offers?.offerClient?.id;
                                                if (!offId) { toast.error(fm('offer.modal.toast.offerNotSavedYet', 'The offer is not saved yet!')); return; }
                                                try {
                                                    await axiosCaller('POST', `offers/${offId}/services`, { services: offerServices });
                                                    toast.success(fm('offer.modal.toast.servicesSaved', 'Services saved!'));
                                                } catch { toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!')); }
                                            }}
                                        >
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                                            <FormattedMessage id="common.action.save" defaultMessage="Save" />
                                        </button>
                                    </div>
                                    {!servicesCollapsed && offerServices.map((svc, idx) => {
                                        const serviceLabel = svc.serviceType === 'transport'
                                            ? fm('offer.modal.services.transport', 'Transport')
                                            : fm('offer.modal.services.installation', 'Installation');
                                        const template = serviceTemplates.find((t: any) => t.serviceType === svc.serviceType);
                                        return (
                                            <div key={svc.serviceType} className="offer-service-row">
                                                <div className="offer-service-top">
                                                    <span className="offer-service-label">{serviceLabel}</span>
                                                    <div className="offer-service-toggle">
                                                        <button
                                                            type="button"
                                                            className={`offer-service-toggle-btn ${svc.enabled ? 'active' : ''}`}
                                                            onClick={() => {
                                                                if (svc.enabled) return;
                                                                const updated = [...offerServices];
                                                                updated[idx] = { ...svc, enabled: true, disabledText: svc.text, text: svc.enabledText || template?.enabledText || '', price: svc.price || 0 };
                                                                setOfferServices(updated);
                                                            }}
                                                        >{fm('offer.modal.services.with', 'With {service}', { service: serviceLabel })}</button>
                                                        <button
                                                            type="button"
                                                            className={`offer-service-toggle-btn ${!svc.enabled ? 'active' : ''}`}
                                                            onClick={() => {
                                                                if (!svc.enabled) return;
                                                                const updated = [...offerServices];
                                                                updated[idx] = { ...svc, enabled: false, enabledText: svc.text, text: svc.disabledText || template?.disabledText || '', price: 0 };
                                                                setOfferServices(updated);
                                                            }}
                                                        >{fm('offer.modal.services.without', 'Without {service}', { service: serviceLabel })}</button>
                                                    </div>
                                                    {svc.enabled && (
                                                        <div className="offer-service-price">
                                                            <input
                                                                type="text"
                                                                inputMode="decimal"
                                                                placeholder={fm('offer.modal.services.pricePlaceholder', 'Value')}
                                                                value={(svc as any).priceText ?? String(svc.price || '')}
                                                                onChange={e => {
                                                                    const val = e.target.value;
                                                                    if (val !== '' && !/^\d*\.?\d*$/.test(val)) return;
                                                                    const updated = [...offerServices];
                                                                    updated[idx] = { ...svc, priceText: val, price: parseFloat(val) || 0 } as any;
                                                                    setOfferServices(updated);
                                                                }}
                                                                onBlur={() => {
                                                                    const updated = [...offerServices];
                                                                    updated[idx] = { ...svc, priceText: undefined } as any;
                                                                    setOfferServices(updated);
                                                                }}
                                                            />
                                                            {svc.serviceType === 'installation' ? (
                                                                <CurrencyDropdown
                                                                    value={svc.currency || 'EUR'}
                                                                    onChange={(cur) => {
                                                                        const updated = [...offerServices];
                                                                        updated[idx] = { ...svc, currency: cur };
                                                                        setOfferServices(updated);
                                                                    }}
                                                                    title={fm('offer.modal.services.currency', 'Currency')}
                                                                />
                                                            ) : (
                                                                <span className="offer-service-currency">EUR</span>
                                                            )}
                                                            {svc.discountPrice != null && (
                                                                <DiscountedPrice original={Number(svc.price || 0)} discounted={Number(svc.discountPrice)} currency={svc.currency || 'EUR'} compact />
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                <textarea
                                                    className="offer-service-text"
                                                    value={svc.text || ''}
                                                    onChange={e => {
                                                        const updated = [...offerServices];
                                                        const newText = e.target.value;
                                                        updated[idx] = {
                                                            ...svc,
                                                            text: newText,
                                                            ...(svc.enabled ? { enabledText: newText } : { disabledText: newText }),
                                                        };
                                                        setOfferServices(updated);
                                                    }}
                                                    rows={2}
                                                    placeholder={svc.enabled
                                                        ? fm('offer.modal.services.descriptionWith', 'Description for with {service}...', { service: serviceLabel.toLowerCase() })
                                                        : fm('offer.modal.services.descriptionWithout', 'Description for without {service}...', { service: serviceLabel.toLowerCase() })}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {/* Comment (Verejtje) */}
                            <div className="offer-comment-input">
                                <div className="offer-comment-header">
                                    <FormattedMessage id="offer.modal.notice" defaultMessage="Notice"/>
                                </div>
                                <textarea
                                    ref={commentRef}
                                    name="comment"
                                    id="commentsInput"
                                    className="offer-comment-textarea"
                                    value={comment || ''}
                                    rows={2}
                                    placeholder={fm('offer.modal.noticePlaceholder', 'Shkruani një vërejtje...')}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* ══════════════ RIGHT PANEL (sidebar) ══════════════ */}
                        <div className="offer-modal-right">

                            {/* Total */}
                            <div className="offer-right-section">
                                {(() => {
                                    const kmshTotal = (props?.products || []).reduce((sum: number, p: any) => {
                                        if (p.canceled === 1 || !p.costPerUnit) return sum;
                                        return sum + (Number(p.costPerUnit) * Number(p.unit || 0));
                                    }, 0);
                                    const hasKmsh = kmshTotal > 0;
                                    return (
                                        <>
                                            <div className="offer-right-label-row">
                                                <p className="offer-right-label">
                                                    {discountedTotal > 0
                                                        ? <FormattedMessage id="offer.modal.totalWithDiscount" defaultMessage="Total with discount" />
                                                        : <FormattedMessage id="offer.list.column.total" defaultMessage="Total" />}
                                                </p>
                                                <div className="offer-right-actions">
                                                    {hasKmsh && (
                                                        <button
                                                            type="button"
                                                            className={`offer-right-info-btn ${showKmsh ? 'offer-right-info-btn--active' : ''}`}
                                                            onClick={() => setShowKmsh(!showKmsh)}
                                                            data-tooltip={fm('offer.kmsh.label', 'COGS')}
                                                            aria-label={fm('offer.kmsh.ariaLabel', 'Margin')}
                                                            aria-expanded={showKmsh}
                                                        >
                                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className={`offer-right-info-btn ${showDiscount ? 'offer-right-info-btn--active' : ''}`}
                                                        onClick={() => setShowDiscount(s => !s)}
                                                        data-tooltip={fm('offer.discount.sectionTitle', 'Discount')}
                                                        aria-label={fm('offer.discount.sectionTitle', 'Discount')}
                                                        aria-expanded={showDiscount}
                                                    >
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <p className="offer-right-value">
                                                {discountedTotal > 0
                                                    ? formatPrice(discountedTotal, ' €')
                                                    : (total != null ? formatPrice(total, ' €') : '0.00 €')
                                                }
                                            </p>
                                            {discountedTotal > 0 && (
                                                <p className="offer-right-gross">
                                                    <FormattedMessage id="offer.modal.grossWithoutDiscount" defaultMessage="Without discount:" /> {total != null ? formatPrice(total, ' €') : '0.00 €'}
                                                </p>
                                            )}
                                            {hasKmsh && showKmsh && (
                                                <div className="offer-kmsh-block">
                                                    <p className="offer-kmsh-block-label"><FormattedMessage id="offer.kmsh.label" defaultMessage="COGS" /></p>
                                                    <p className="offer-kmsh-block-value">{formatPrice(kmshTotal, ' €')}</p>
                                                </div>
                                            )}
                                            {showDiscount && (
                                                <div className="offer-discount-wrap">
                                                    <div className="discount-section">
                                                        <div className="discount-controls">
                                                            <div className="discount-field">
                                                                <p className="discount-field-label"><FormattedMessage id="offer.discount.typeLabel" defaultMessage="Discount type" /></p>
                                                                <MikaSelect
                                                                    options={discountTypeOptions}
                                                                    placeholder={fm('offer.discount.typePlaceholder', 'Choose type')}
                                                                    value={selectedDiscountType}
                                                                    setEntireOptionFunction={handleDiscountTypeChange}
                                                                />
                                                            </div>
                                                            <div className="discount-field">
                                                                <p className="discount-field-label">
                                                                    {discountType?.value === 1
                                                                        ? <FormattedMessage id="offer.discount.valuePercent" defaultMessage="Discount (%)" />
                                                                        : <FormattedMessage id="offer.discount.valueFixed" defaultMessage="Discount (€)" />}
                                                                </p>
                                                                <input
                                                                    className="discount-amount-input"
                                                                    name="discountValue"
                                                                    type="number"
                                                                    min={0}
                                                                    step="0.01"
                                                                    onWheel={(e) => (e.target as HTMLInputElement).blur()}
                                                                    value={discountValue || ''}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                                        discountType?.value !== null && discountType?.value !== undefined
                                                                            ? setDiscountValue(e.target.value as any)
                                                                            : undefined
                                                                    }
                                                                    disabled={discountType?.value == null}
                                                                    placeholder="0"
                                                                    autoComplete="off"
                                                                />
                                                            </div>
                                                        </div>
                                                        {discountedTotal > 0 && discountRapport && (
                                                            <div className="discount-rapport">
                                                                <span className="discount-rapport-label"><FormattedMessage id="offer.discount.applied" defaultMessage="Applied discount" /></span>
                                                                <span className="discount-rapport-value">{discountRapport}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}
                            </div>

                            {/* Attachments — hidden file inputs */}
                            <input
                                ref={projectFileInputRef}
                                type="file"
                                accept="image/jpeg,image/jpg,image/png,image/webp,application/pdf"
                                multiple
                                style={{ display: 'none' }}
                                onChange={(e) => handleAttachFiles(e, 'project')}
                            />
                            <input
                                ref={similarFileInputRef}
                                type="file"
                                accept="image/jpeg,image/jpg,image/png,image/webp,application/pdf"
                                multiple
                                style={{ display: 'none' }}
                                onChange={(e) => handleAttachFiles(e, 'similar')}
                            />

                            {/* Project attachments block */}
                            <div className="attachment-section">
                                <Button
                                    isLoading={attachUploading}
                                    isDisabled={attachUploading}
                                    onClick={() => projectFileInputRef.current?.click()}
                                    className="w-100 align-items-center px-3 calculateOfferButton">
                                    <FormattedMessage id="offer.modal.attachments.attachProject" defaultMessage="Attach project"/>
                                </Button>
                                {attachLoading ? <Spinner/> : (
                                    attachments.filter((a: any) => a.type === 'project').length > 0 && (
                                        <>
                                            <p className="attachment-category-label"><FormattedMessage id="offer.modal.attachments.projectDocs" defaultMessage="Project documentation" /></p>
                                            <div className="attachment-list">
                                                {attachments.filter((a: any) => a.type === 'project').map((att: any) => (
                                                    <div className="attachment-item" key={att.id}>
                                                        {att.mimeType !== 'application/pdf' ? (
                                                            <img
                                                                src={att.data ? `data:${att.mimeType};base64,${att.data}` : att.url}
                                                                alt={att.originalName}
                                                                className="attachment-thumb"
                                                            />
                                                        ) : (
                                                            <div className="attachment-pdf-icon">
                                                                <img src={FileIcon} alt="pdf"/>
                                                            </div>
                                                        )}
                                                        <span className="attachment-name">{att.originalName}</span>
                                                        <img
                                                            src={xSign}
                                                            alt={fm('common.action.delete', 'Delete')}
                                                            className="attachment-delete"
                                                            onClick={() => handleDeleteAttachment(att.id)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )
                                )}
                            </div>

                            {/* Similar attachments block */}
                            <div className="attachment-section">
                                <Button
                                    isLoading={attachUploading}
                                    isDisabled={attachUploading}
                                    onClick={() => similarFileInputRef.current?.click()}
                                    className="w-100 align-items-center px-3 calculateOfferButton">
                                    <FormattedMessage id="offer.modal.attachments.attachSimilar" defaultMessage="Attach similar photos"/>
                                </Button>
                                {attachLoading ? <Spinner/> : (
                                    attachments.filter((a: any) => a.type === 'similar').length > 0 && (
                                        <>
                                            <p className="attachment-category-label"><FormattedMessage id="offer.modal.attachments.referencePhotos" defaultMessage="Reference photos" /></p>
                                            <div className="attachment-list">
                                                {attachments.filter((a: any) => a.type === 'similar').map((att: any) => (
                                                    <div className="attachment-item" key={att.id}>
                                                        {att.mimeType !== 'application/pdf' ? (
                                                            <img
                                                                src={att.data ? `data:${att.mimeType};base64,${att.data}` : att.url}
                                                                alt={att.originalName}
                                                                className="attachment-thumb"
                                                            />
                                                        ) : (
                                                            <div className="attachment-pdf-icon">
                                                                <img src={FileIcon} alt="pdf"/>
                                                            </div>
                                                        )}
                                                        <span className="attachment-name">{att.originalName}</span>
                                                        <img
                                                            src={xSign}
                                                            alt={fm('common.action.delete', 'Delete')}
                                                            className="attachment-delete"
                                                            onClick={() => handleDeleteAttachment(att.id)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )
                                )}
                            </div>

                            {/* Action buttons */}
                            <div className="d-flex flex-column w-100 button-container gap-2">
                                <Button
                                    isLoading={savePdfLoader}
                                    isDisabled={savePdfLoader}
                                    onClick={savePdfToServer}
                                    className="w-100 align-items-center px-3 text-center calculateOfferButton">
                                    <FormattedMessage id="offer.modal.savePdf" defaultMessage="Save offer as file"/>
                                </Button>
                                {((!props.permissions.observer) || props.permissions.fullPrivileges) && (
                                    <Button
                                        isLoading={saveOfferLoading || props?.buttonLoader}
                                        isDisabled={saveOfferLoading || props?.buttonLoader}
                                        onClick={saveOffer}
                                        className="w-100 align-items-center px-3 text-center calculateOfferButton">
                                        <FormattedMessage id="offer.form.saveOffer" defaultMessage="Save offer"/>
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </FormikFormWrapper>

                {/* Date update overlay */}
                {updateDatesPayload?.productId && (
                    <div className="updateStartDateModalContainer">
                        <div className="updateStartDateModal">

                            {/* Header */}
                            <div className="date-modal-header">
                                <FontAwesome name="calendar" className="date-modal-header-icon"/>
                                <span><FormattedMessage id="offer.modal.dateUpdate.title" defaultMessage="Change dates" /></span>
                            </div>

                            {/* Date range row */}
                            <div className="date-range-row">
                                <div className="date-field">
                                    <label className="date-field-label"><FormattedMessage id="offer.modal.dateUpdate.startLabel" defaultMessage="Start" /></label>
                                    <DatePicker
                                        selected={updatedStartDate ? new Date(updatedStartDate) : null}
                                        onChange={(date) => setUpdatedStartDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="DD/MM/YYYY"
                                        className="date-field-input"
                                        calendarClassName="modern-datepicker-calendar"
                                        popperPlacement="bottom-start"
                                        portalId="datepicker-portal"
                                        minDate={new Date()}
                                        popperModifiers={[{ name: 'offset', options: { offset: [0, isMobile ? -40 : -8] } }] as any}
                                        formatWeekDay={(d: string) => {
                                            const idx = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].indexOf(d);
                                            if (idx < 0) return d.charAt(0);
                                            return new Intl.DateTimeFormat(props.intl.locale, { weekday: 'narrow' }).format(new Date(2000, 0, 2 + idx));
                                        }}
                                        renderCustomHeader={(p: any) => <CalendarHeader {...p} />}
                                    />
                                </div>
                                <div className="date-range-arrow">
                                    <FontAwesome name="arrow-right"/>
                                </div>
                                <div className="date-field">
                                    <label className="date-field-label"><FormattedMessage id="offer.modal.dateUpdate.endLabel" defaultMessage="End" /></label>
                                    <DatePicker
                                        selected={updatedEndDate ? new Date(updatedEndDate) : null}
                                        onChange={(date) => setUpdatedEndDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="DD/MM/YYYY"
                                        className="date-field-input"
                                        calendarClassName="modern-datepicker-calendar"
                                        popperPlacement="bottom-start"
                                        portalId="datepicker-portal"
                                        minDate={updatedStartDate ? new Date(updatedStartDate) : new Date()}
                                        popperModifiers={[{ name: 'offset', options: { offset: [0, isMobile ? -40 : -8] } }] as any}
                                        formatWeekDay={(d: string) => {
                                            const idx = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].indexOf(d);
                                            if (idx < 0) return d.charAt(0);
                                            return new Intl.DateTimeFormat(props.intl.locale, { weekday: 'narrow' }).format(new Date(2000, 0, 2 + idx));
                                        }}
                                        renderCustomHeader={(p: any) => <CalendarHeader {...p} />}
                                    />
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="date-modal-actions">
                                <Button
                                    isLoading={props?.buttonLoader}
                                    isDisabled={props?.buttonLoader}
                                    onClick={closeDateModal}
                                    className="date-btn date-btn--cancel">
                                    <FormattedMessage id="common.confirm.cancel" defaultMessage="Cancel"/>
                                </Button>
                                <Button
                                    isLoading={props?.buttonLoader}
                                    isDisabled={props?.buttonLoader}
                                    onClick={saveStartAndEndDate}
                                    className="date-btn date-btn--save">
                                    <FormattedMessage id="offer.modal.dateUpdate.saveDates" defaultMessage="Save dates"/>
                                </Button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}


function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        offers: state.offers,
        admin: state.admin
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        offerActions: bindActionCreators(offerActions as any, dispatch),
        actions: bindActionCreators(actions as any, dispatch),
        productionActions: bindActionCreators(productionActions as any, dispatch)
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(CalculateOfferModal as any)));
